export default [
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      loggedInNotRequired: true
    }
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/SignUp.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      loggedInNotRequired: true
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      loggedInNotRequired: true
    }
  },
  {
    path: '/user/reset-password',
    name: 'reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      loggedInNotRequired: true
    }
  },
  {
    path: '/users/verify-user',
    name: 'verify-user',
    component: () => import('@/views/pages/authentication/VerifyUser.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      loggedInNotRequired: true
    },
    props: route => ({
      token: route.query.token
    })
  }
];
